
import GwIcon from '~/patterns/atoms/icon/icon.vue';
export default {
    components: {
        GwIcon
    },
    props: {
        stars: {
            type: Number,
            default: 4
        }
    },
    computed: {
        width() {
            return 100 / (5 / this.stars);
        }
    }
};
